import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 71165 43547"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:1031.38}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970270334656">
        <path
          d="M47719 1209c-925 924-925 2421 0 3347 923 924 2422 924 3346 0 924-925 924-2423 0-3347-923-924-2423-924-3346 0zM54017 7505c-925 924-925 2423 0 3346 924 923 2421 923 3345 0 924-925 924-2423 0-3346-924-924-2421-924-3345 0zM60314 13803c-925 924-925 2423 0 3346 923 924 2422 924 3345 0 924-923 924-2422 0-3346-922-925-2422-925-3345 0zM66611 20100c-923 924-923 2421 0 3346 925 924 2422 924 3347 0 923-925 923-2422 0-3346-925-924-2423-924-3347 0zM47719 42337c-925-923-925-2420 0-3346 923-924 2422-924 3346 0 924 926 924 2423 0 3346-923 925-2423 925-3346 0zM54017 36041c-925-925-925-2423 0-3346 924-925 2421-925 3345 0 924 924 924 2422 0 3346s-2421 924-3345 0zM60314 29744c-925-925-925-2423 0-3346 923-925 2422-925 3345 0 924 923 924 2421 0 3346-922 923-2422 923-3345 0z"
          className="fill stroke1"
          style={{
            strokeWidth: 1031.38,
          }}
        />
        <path
          d="M66611 23446c-923-925-923-2422 0-3346 925-925 2422-925 3347 0 923 924 923 2421 0 3346-925 924-2423 924-3347 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1031.38,
          }}

        />
      </g>
      <g id="_1970248769392">
        <path
          d="M27233 21772c0 1308 1059 2367 2366 2367s2366-1059 2366-2367c0-1305-1060-2366-2366-2366s-2366 1061-2366 2366zM36139 21772c0 1308 1059 2367 2367 2367 1304 0 2365-1059 2365-2367 0-1305-1061-2366-2365-2366-1308 1-2367 1061-2367 2366zM45043 21772c0 1308 1060 2367 2366 2367 1307 0 2366-1059 2366-2367 0-1305-1058-2366-2366-2366-1306 1-2366 1061-2366 2366zM53949 21772c0 1308 1061 2367 2366 2367 1307 0 2367-1059 2367-2367 0-1305-1059-2366-2367-2366-1305 1-2366 1061-2366 2366z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1031.38,
          }}

        />
      </g>
      <g id="_1970272032976">
        <path
          d="M516 21772c0 1308 1059 2367 2366 2367 1305 0 2365-1059 2365-2367 0-1305-1060-2366-2365-2366-1307 1-2366 1061-2366 2366zM9421 21772c0 1308 1059 2367 2367 2367 1305 0 2365-1059 2365-2367 0-1305-1060-2366-2365-2366-1308 1-2367 1061-2367 2366zM18328 21772c0 1308 1058 2367 2365 2367 1306 0 2366-1059 2366-2367 0-1305-1060-2366-2366-2366-1306 1-2365 1061-2365 2366z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1031.38,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
